import Vue from 'vue';
import { PiniaVuePlugin, createPinia } from 'pinia';
import VueCompositionAPI from '@vue/composition-api';

Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin);

const pinia = createPinia();

export default pinia;
